import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";

export const Wrapper = styled(Card)`
  width: 100%;
  margin: 20px 0;
`;
